import { useEffect } from 'react';
import { HotelRecord, Timeframe } from '../../../../common/types';
import {
  convertToKeenFriendlyHotelTimeframe,
  useKeenQuery,
} from '../../../../utils/keen';

const usePageViewsByCategoryData = ({
  hotel,
  timeframe,
}: {
  hotel: HotelRecord;
  timeframe: Timeframe;
}) => {
  const [
    { data: pageViewsByCategory = [], loading: isPageViewsByCategoryLoading },
    queryPageViewsByCategory,
  ] = useKeenQuery<{ categoryId: string; result: number }[]>();

  useEffect(() => {
    queryPageViewsByCategory({
      analysisType: 'count',
      eventCollection: 'page_views',
      groupBy: 'category_id',
      filters: [
        {
          propertyName: 'hotel_uuid',
          operator: 'eq',
          propertyValue: hotel.uuid,
        },
      ],
      timeframe:
        typeof timeframe === 'string'
          ? timeframe
          : convertToKeenFriendlyHotelTimeframe(timeframe, hotel.tzInfoId),
      timezone: hotel.tzInfoId,
    });
  }, [hotel.uuid, queryPageViewsByCategory, timeframe, hotel.tzInfoId]);

  return { data: pageViewsByCategory, loading: isPageViewsByCategoryLoading };
};

export default usePageViewsByCategoryData;
